import { defineVariable, type NegotiationVariable } from '../core/define'

/**
 * Los dominios SUELTOS: proyecto, sociedad, propietario, asesor, documento y otros.
 *
 * Cada `defineVariable` referencia el metadato canónico por su key —declarado en
 * `@idc-forms/schemas/variables/document/misc.variables`— y aporta lo único que no viaja: cómo se
 * resuelve el valor contra la negociación cargada (ADR 0036).
 */

const str = (v: unknown): string => (v === undefined || v === null ? '' : String(v))

// 🏢 Proyecto
export const PROJECT_VARIABLES: NegotiationVariable[] = [
  defineVariable('nombre_proyecto', (c) => str(c.project?.name)),
  defineVariable('codigo_proyecto', (c) => str(c.project?.code))
]

// 👤 Sociedad
export const SOCIETY_VARIABLES: NegotiationVariable[] = [
  defineVariable('nombre_sociedad', (c) => str(c.society?.name))
]

// 👥 Propietario (datos ya derivados en ctx.owner por el orquestador)
export const OWNER_VARIABLES: NegotiationVariable[] = [
  defineVariable('nombre_propietario', (c) => str(c.owner?.nombre_propietario)),
  defineVariable('nit_propietario', (c) => str(c.owner?.nit_propietario)),
  defineVariable('email_propietario', (c) => str(c.owner?.email_propietario)),
  defineVariable('telefono_propietario', (c) => str(c.owner?.telefono_propietario)),
  defineVariable('nombre_representante_legal', (c) => str(c.owner?.nombre_representante_legal)),
  defineVariable('nit_representante_legal', (c) => str(c.owner?.nit_representante_legal)),
  defineVariable('email_representante_legal', (c) => str(c.owner?.email_representante_legal)),
  defineVariable('telefono_representante_legal', (c) => str(c.owner?.telefono_representante_legal)),
  defineVariable('nombre_propietario_representante_legal', (c) =>
    str(c.owner?.nombre_propietario_representante_legal)
  )
]

// 👨‍💼 Asesor
export const ADVISOR_VARIABLES: NegotiationVariable[] = [
  defineVariable('nombre_asesor', (c) => str(c.advisor?.fullname))
]

// 📄 Documento
export const DOCUMENT_VARIABLES: NegotiationVariable[] = [
  defineVariable('fecha_impresion', (c) => c.computed?.fecha_impresion ?? '')
]

// 🔄 Otros
export const OTHER_VARIABLES: NegotiationVariable[] = [
  defineVariable('fecha_de_hoy', (c) => c.computed?.fecha_de_hoy ?? ''),
  defineVariable('hora_actual', (c) => c.computed?.hora_actual ?? '')
]
